export default __webpack_public_path__ + "static/media/pe-pp-lumps.35a54f5f.jpg";